export * from './generated/supported-languages.plk';
